import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import ResponsivePicture from "../modules/ResponsivePicture.jsx";
import Icon from "../modules/Icon.jsx";
class MenuLink extends React.PureComponent {
	constructor(props) {
		super(props);
		this.callRemovable = this.callRemovable.bind(this);
	}
	componentDidMount() {
		this.props.dispatch({
			type: "REQUEST_ROUTE",
			payload: {
				type: this.props.type,
				slug: this.props.url.split("/")[2].replace(".html", ""),
				config: this.props.config
			}
		});
	}
	callRemovable() {
		this.props.removableFunc(this);
	}
	render() {
		const { url, name, img, removable = 0, showLoading, cdn } = this.props;
		return (
			<li className={removable ? "removable" : null}>
				<Link to={url}>
					<ResponsivePicture
						route={img}
						key={img}
						width="60"
						device="mobile"
						type="search"
						isRetina={this.props.is_retina}
						alt={name}
						isLoading={showLoading}
						cdn={cdn}
						supports_webp={this.props.supports_webp}
					/>
					<span className="title">{name}</span>
				</Link>
				{removable ? (
					<span role="button" onClick={this.callRemovable}>
						{" "}
						<Icon icon={"faTimes"} />{" "}
					</span>
				) : null}
			</li>
		);
	}
}
MenuLink.propTypes = {
	url: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	isMobile: PropTypes.bool.isRequired,
	removable: PropTypes.bool,
	removableFunc: PropTypes.func,
	dispatch: PropTypes.func.isRequired,
	type: PropTypes.string.isRequired,
	id: PropTypes.string
};

MenuLink.defaultProps = {
	removableFunc: () => {},
	removable: false,
	showLoading: false
};
function mapStateToProps(state) {
	return {
		config: state.config,
		supports_webp: state.config.supports_webp,
		cdn: state.config.mediaCDN
	};
}

export default connect(mapStateToProps)(MenuLink);
